import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/others/compliance.png")